import { useQuery } from '@tanstack/react-query';
import { Loader2 } from 'lucide-react';
import { useRoute } from 'wouter';
import { getAssignedStudent } from '../../lib/admin-api';
import MyPage from '../mypage';

export default function TeacherStudentMyPage() {
  const [, params] = useRoute('/teacher/students/:studentId');
  const studentId = Number.parseInt(params?.studentId ?? '', 10);
  const validStudentId = Number.isInteger(studentId) && studentId > 0;
  const { data, isLoading, error } = useQuery({
    queryKey: ['teacher', 'assigned-student', studentId],
    queryFn: () => getAssignedStudent(studentId),
    enabled: validStudentId,
    staleTime: 60 * 1000,
  });

  if (!validStudentId || error) {
    return (
      <div className="grid min-h-screen place-items-center bg-gray-50 p-6 text-center text-red-700">
        担当学生の情報を表示できません。
      </div>
    );
  }

  if (isLoading || !data) {
    return (
      <div className="flex min-h-screen items-center justify-center gap-2 bg-gray-50 text-gray-600">
        <Loader2 className="h-5 w-5 animate-spin" />
        読み込み中...
      </div>
    );
  }

  return (
    <MyPage
      viewedStudent={{
        id: data.student.id,
        name: data.student.name,
        participantCode: data.student.participant_code,
      }}
    />
  );
}
